<template>
  <el-menu
    :ellipsis="false"
    class="header-menu c_font14"
    mode="horizontal"
    :popper-offset="16"
    style="max-width: 800px"
    :default-active="appName"
  >
    <el-menu-item
      v-for="menu in menus"
      :key="menu.name"
      :index="menu.name"
      class="c_padding_l5 c_padding_r5"
      @click="handleClickMenu(menu)"
    >
      <div class="c_flex_row header-menu__item">
        <app-icon
          class="c_margin_r5"
          :name="menu.icon"
          color="var(--app-color-text)"
        />
        <span class="c_font14">{{ menu.label }}</span>
      </div>
    </el-menu-item>
  </el-menu>
</template>

<script lang="ts" setup>
import { onMounted, reactive, computed, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import shared from '@/micro/shared'
import { IWorkBenchItem } from '@y/types'
import initApps from '@/micro'

const router = useRouter()
const appName = computed(() => shared.getAppName())

let menus: IWorkBenchItem[] = reactive([
  {
    label: '工作台',
    name: 'admin',
    path: '/work-bench',
    icon: 'bar-chart-box-ai-fill',
    isContainerMenu: true,
  },
])

onMounted(() => {
  initMenus()
})

const redirectUrl = (url: string) => {
  sessionStorage.removeItem('redirect')
  nextTick(() => {
    router.replace(url)
  })
}

// 查询数据
const initMenus = async () => {
  const storageMenus = shared.getWorkBenchMenus()
  const redirect = sessionStorage.getItem('redirect')
  if (storageMenus && storageMenus.length > 0) {
    menus = storageMenus
    initApps()
    if (redirect) {
      nextTick(() => {
        redirectUrl(redirect)
      })
    }
    return
  }
  const data = shared.getRouters()
  if (data && data.children && data.children?.length > 0) {
    const user = shared.getUser()
    const resources = user?.resources
    data.children.forEach(child => {
      const { code, type } = child
      if (resources?.includes(code) && ['1', '5'].includes(type)) {
        const { text, urlPath, attributes } = child
        const item = {
          label: text,
          name: urlPath.replace('/', ''),
          path: urlPath,
          icon: attributes?.resourceIcon || 'apps',
          isContainerMenu: true,
        }
        if (type === '5') {
          item.isContainerMenu = false
        }
        menus.push(item)
      }
    })
    shared.setWorkBenchMenus(menus)
    initApps()
    if (redirect) {
      nextTick(() => {
        redirectUrl(redirect)
      })
    }
  }
}

const handleClickMenu = (menu: IWorkBenchItem) => {
  const { isContainerMenu } = menu
  let path = menu.path
  if (!isContainerMenu) {
    path = `/app${menu.path}/`
  }
  router.push(path)
}
</script>

<style lang="less" scoped>
.header-menu {
  --el-menu-bg-color: transparent;
  --el-menu-text-color: @mainFontColor;
  --el-menu-hover-bg-color: transparent;
  --el-menu-hover-text-color: @whiteColor;
  --el-menu-active-color: @whiteColor;
  border-bottom: none !important;

  .header-menu__item {
    height: 30px;
    padding: 8px 12px;
    border-radius: 8px;
    transition: background 0.2s;
  }
}
</style>
<style lang="less">
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none !important;

  .header-menu__item {
    background: @mainColor;

    i {
      color: @whiteColor !important;
    }
  }
}

.el-menu-item:hover {
  .header-menu__item {
    background: @mainColor;

    i {
      transform: scale(1.2);
      color: @whiteColor !important;
    }
  }
}
</style>
